/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';

import { PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import destinationSignatures from '../../signatures/operationSignaturesDestinations.json';
import { getSubDirectoryLocale } from '@marriott/mi-leisure-components/utils';
import { PARAM_PAGENO } from '@marriott/mi-leisure-components/constants';

const { REDIRECT_URL_DESTINATION } = process.env;

function pageRenderer(props) {
  console.log('[destination] props ', props);
  const url = props.model['canonical'] !== '' ? new URL(props.model['canonical'], props.model['canonical']) : ''; // Base URL needed to parse relative URL
  const param = PARAM_PAGENO;
  if (url !== '' && url.searchParams.has(param)) {
    if (props.pageNo === '1') {
      url.searchParams.delete(param);
    } else {
      url.searchParams.set(param, props.pageNo); // Update the parameter value
    }
  } else {
    if (url !== '' && props.pageNo != null && props.pageNo !== '1') {
      url.searchParams.append(param, props.pageNo); // Add it if it doesn't exist
    }
  }
  const baseUrl = url.toString();
  props.model['canonical'] = baseUrl;
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const destinationSpecificData = async (context: any, parallelCallsResponse: any, interceptorResponse: any) => {
  console.log('[destinationSpecificData] offers context -', context);
  console.log('[destinationSpecificData page] parallelCallsResponse ', parallelCallsResponse);
  const currentLocale = interceptorResponse?.requestAttributes?.pageManagerRequest?.global?.localeKey?.replace(
    '_',
    '-'
  );
  const { req } = context;
  let pageNo = null;
  const isAuthorMode = req?.url?.includes('isAuthorMode');
  if (!isAuthorMode) {
    const url = new URL(req.url, `http://${req.headers.host}`); // Use the full URL
    //capturing query param pageNO from req url
    pageNo = url.searchParams.get(PARAM_PAGENO);
  }
  const redirectUrlWithSubdirectory = `/${getSubDirectoryLocale(currentLocale)}${REDIRECT_URL_DESTINATION}`;
  return {
    operationSignatures: destinationSignatures,
    redirectUrI: redirectUrlWithSubdirectory,
    pageNo: pageNo,
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(destinationSpecificData);
export default pageRenderer;
